import { verifyCardValidations } from 'shared-components/src/validations/cardValidations';
import { verifyRegisterValidations } from 'shared-components/src/validations/cardholderValidations';
import { digitsOnly, expandExpiry, expectedCvvLength } from './cardFormatting';

// The validators below store an i18n key, not translated text, so an error already on screen
// follows a language switch. Render a stored error through errorMessage.
export const errorMessage = (intl, error) => intl.messages[error] || error;

// Error for one CardFields input (card number, CVV, or MM/YY expiry), as an i18n key, or '' when
// the value is valid. Registration, activation and RBC onboarding all validate through this so
// they agree.
export const cardFieldError = (key, values) => {
  const digits = digitsOnly(values.cardNumber);

  switch (key) {
  case 'cardNumber':
    if (!digits) return 'errors-cardnumber-required';
    return verifyCardValidations.cardNumber(digits) ? '' : 'errors-cardnumber-invalid';
  case 'cvv':
    if (!values.cvv) return 'errors-cvv-required';
    // Exact length for the network, not just "at least 3" -- a 3-digit code on an Amex card
    // would otherwise pass here and only fail at the API.
    return verifyCardValidations.cvv(values.cvv) && values.cvv.length === expectedCvvLength(digits)
      ? ''
      : 'errors-cvv-invalid';
  case 'expiry':
    if (!values.expiry) return 'errors-expiry-required';
    return verifyCardValidations.expiry(expandExpiry(values.expiry)) ? '' : 'errors-expiry-invalid';
  default:
    return '';
  }
};

export const validateUsername = (setValidationErrors, userInfo) => {
  setValidationErrors({
    key: 'username',
    value: !verifyRegisterValidations.username(userInfo.username) ? 'errors-username-invalid' : false,
  });
};
export const validatePassword = (setValidationErrors, userInfo) => {
  setValidationErrors({
    key: 'password',
    value: !verifyRegisterValidations.password(userInfo.password) ? 'errors-password-invalid' : false,
  });
};
// validate confirm password
export const validateConfirmPassword = (setValidationErrors, userInfo) => {
  setValidationErrors({
    key: 'passwordConfirmation',
    value: userInfo.password !== userInfo.passwordConfirmation ? 'errors-password-confirmation-invalid' : false,
  });
};

export const checkForValidationErrors = (validationErrors, setError) => {
  if (
    Object.keys(validationErrors).find(field => validationErrors[field] === true)
  ) {
    return setError(
      'errors-form-invalid'
    );
  }

  return false;
};
